<template>
  <div class="row m-0">
    <div class="col-12 mt-3 card orderOtpBox">
      <h6 id="checkout-oder-summary-heading"
										data-test="orderOtpVerificationHead1"
						>
        Verify User (Email/Phone)
      </h6>
      <ul
        class="nav nav-pills mb-3 mt-3 justify-content-around justify-content-md-start"
        id="pills-tab"
        role="tablist"
      >
        <li class="nav-item">
          <a
            class="nav-link active "
            id="pills-email-tab"
            data-toggle="pill"
            href="#pills-home"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
												data-test="orderOtpVerificationEmailLink"
          >
            <div class="icon icon--ei-envelope icon--s">
              <img
                class="icon_cnt"
                src="@/assets/svg/ei-envelope.svg"
                alt="Email"
                srcset=""
                id="pills-email-img"
																data-test="orderOtpVerificationEmailLinkImg"
              >
            </div>
            Email
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-phone-tab"
            data-toggle="pill"
            href="#pills-profile"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
												data-test="orderOtpVerificationPhnLink"
          >
            <div class="icon icon--ei-envelope icon--s">
              <img
                class="icon_cnt"
                src="@/assets/svg/ei-phone.svg"
                alt="Phone"
                srcset=""
                style="height: 20px;"
                id="pills-phone-img"
																data-test="orderOtpVerificationPhnLinkImg"
              >
            </div>
            Phone Number
          </a>
        </li>
      </ul>
      <div
        class="tab-content"
        id="pills-tabContent"
      >
        <div
          class="tab-pane fade show active"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-email-tab"
        >
          <form
            data-vv-scope="verify-email-otp"
            @submit.prevent="action('verify-email-otp')"
          >
            <div class="col-12 float-left">
              <div
                class="input-group col-12 col-md-6 p-0"
                style="max-width: 400px;"
              >
                <input
                  class="col-12 form-control
                              login-signup-input
                              otp-code-input mx-auto mt-3"
                  :class="(errors.has('verify-email-otp.email'))?'is-invalid':''"
                  id="verification-mail-id"
                  type="text"
                  name="email"
                  v-model="email"
                  autocomplete="off"
                  placeholder="Email "
                  v-validate="'required|email'"
                  data-ismobileonly="false"
                  disabled
																		data-test="orderOtpVerificationEmailInput"
                >
                <div
                  class="invalid-feedback"
                  v-show="errors.has('verify-email-otp.email')"
                  id="verification-mail-id-error"
																		data-test="orderOtpVerificationEmailInputError"
                >
                  {{errors.first('verify-email-otp.email')}}
                </div>
              </div>
              <div class="input-group col-md-6 justify-content-center justify-content-md-start">
                <button
                  class="btn btn-sm blue-btn mt-3 mb-2 float-right"
                  type="submit"
                  v-if="!otpSendEmail"
                  id="verification-mail-otp-btn"
                  v-loading="loadingSend"
                  @click="otpSendPhn=false"
																		data-test="orderOtpVerificationSendBtn"
                >
                  Send Otp
                </button>
              </div>
              <div
                class="input-group col-12 col-md-6 p-0"
                style="max-width: 400px;"
                v-if="otpSendEmail"
              >
                <input
                  class="col-12 form-control login-signup-input
                               otp-code-input mt-3 mx-auto"
                  type="text"
                  autocomplete="off"
                  placeholder="Enter the OTP"
                  id="verification-mail-otp"
                  data-ismobileonly="false"
                  name="otp"
                  v-model="otp"
                  maxlength="6"
                  @keypress="isNumValid($event)"
                  @paste="cleanPhoneNumber"
																		data-test="orderOtpVerificationOtpInput"
                >
                <!--<div class="invalid-feedback"-->
                <!--v-show="errors.has('verify-email-otp.otp')"-->
                <!--id="verification-mail-otp-error">-->
                <!--{{errors.first('verify-email-otp.otp')}}-->
                <!--</div>-->
              </div>
            </div>
            <div
              class="col-12 col-md-12"
              v-if="otpSendEmail"
            >
              <a
                class="text-center mx-auto d-block mt-3 float-left"
                href="#"
                @click.prevent="sendOtp('email')"
                id="verification-mail-resend"
																data-test="orderOtpVerificationResendOtpLink"
              >
                Resend OTP
              </a>
              <button
                class="btn btn-sm blue-btn mt-3 mb-2 float-right"
                type="submit"
                id="verification-mail-verify-otp-btn"
                v-loading="loading"
																data-test="orderOtpVerificationVerifyBtn"
              >
                Verify OTP and Place Order
              </button>
            </div>
          </form>
        </div>

        <div
          class="tab-pane fade"
          id="pills-profile"
          role="tabpanel"
          aria-labelledby="pills-phone-tab"
        >
          <form
            data-vv-scope="verify-phone-otp"
            @submit.prevent="action('verify-phone-otp')"
          >
            <div class="col-12 float-left">
              <div
                class="input-group col-12 col-md-6 p-0"
                style="max-width: 400px;"
              >
                <input
                  class="col-12 form-control login-signup-input
                               otp-code-input mx-auto mt-3"
                  id="verification-phon-no"
                  type="text"
                  name="phone"
                  :class="(errors.has('verify-phone-otp.phone'))?'is-invalid':''"
                  v-model="phone"
                  autocomplete="off"
                  placeholder="Phone "
                  v-validate="'required|min:10|numeric'"
                  data-ismobileonly="false"
                  disabled
																		data-test="orderOtpVerificationPhnInput"
                >
                <div
                  class="invalid-feedback"
                  v-show="errors.has('verify-phone-otp.phone')"
                  id="verification-phon-no-error"
																		data-test="orderOtpVerificationPhnInputError"
                >
                  {{errors.first('verify-phone-otp.phone')}}
                </div>
              </div>
              <div class="input-group col-6">
                <button
                  class="btn btn-sm blue-btn mt-3 mb-2 float-right"
                  type="submit"
                  v-if="!otpSendPhn"
                  id="verification-phon-oto-btn"
                  v-loading="loadingSend"
                  @click="otpSendEmail=false"
																		data-test="orderOtpVerificationPhnSndBtn"
                >
                  Send Otp
                </button>
              </div>
              <div
                class="input-group col-12 col-md-6 px-0 "
                style="max-width: 400px;"
                v-if="otpSendPhn"
              >
                <input
                  class="col-12 form-control login-signup-input
                               otp-code-input mt-3 mx-auto"
                  type="text"
                  autocomplete="off"
                  placeholder="Enter the OTP"
                  id="verification-phon-otp"
                  data-ismobileonly="false"
                  name="otp"
                  v-model="otp"
                  maxlength="6"
                  @keypress="isNumValid($event)"
                  @paste="cleanPhoneNumber"
																		data-test="orderOtpVerificationPhnOtpInput"
                >
                <!--<div class="invalid-feedback"-->
                <!--v-show="errors.has('verify-phone-otp.otp')"-->
                <!--id="verification-phon-no-otp-error">-->
                <!--{{errors.first('verify-phone-otp.otp')}}-->
                <!--</div>-->
              </div>
            </div>
            <div
              class="col-12 col-md-12"
              v-if="otpSendPhn"
            >
              <a
                class="text-center mx-auto d-block mt-3 float-left"
                href="#"
                @click.prevent="sendOtp('phone')"
                id="verification-phon-no-resend"
																data-test="orderOtpVerificationPhnResendLink"
              >
                Resend OTP
              </a>
              <button
                class="btn btn-sm blue-btn mt-3 mb-2 float-right"
                type="submit"
                id="verification-phon-no-verify-otp-btn"
                v-loading="loading"
																data-test="orderOtpVerificationPhnVerifyBtn"
              >
                Verify OTP and Place Order
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import { orderApi } from '@/services/ApiServices/orderApi'

export default {
	name: 'order-otp-verification',
	data () {
		return {
			phone: '',
			email: '',
			showOtpError: false,
			otp: '',
			otpSendEmail: false,
			otpSendPhn: false,
			verificationMethod: 'phone',
			loadingSend: '',
			loading: ''
		}
	},
	mounted () {
		this.phone = this.getUserData.phone_number
		this.email = this.getUserData.email
	},
	computed: {
		...mapGetters('user', ['isAuthenticated', 'getSelectedAddress', 'getUserData']),
		...mapGetters('cart', ['getOrderCart'])
	},
	watch: {
		getUserData: {
			handler () {
				this.phone = this.getUserData.phone_number
				this.email = this.getUserData.email
			},
			deep: true
		}
	},
	methods: {
		action (scope) {
			const verificationMethod = scope === 'verify-phone-otp' ? 'phone' : 'email'
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.sendOrConfirmOTPViaChosenMethod(verificationMethod)
				}
			})
		},
		sendOtp (verificationMethod) {
			this.otp = ''
			if (this.isAuthenticated) {
				if (verificationMethod === 'phone') {
					this.otpSendPhn = false
					this.loadingSend = orderApi.sendOtp(this.phone)
						.then(() => {
							this.otpSendPhn = true
						})
				} else if (verificationMethod === 'email') {
					this.otpSendEmail = false
					this.loadingSend = orderApi.sendOrderOTPEmail(this.email)
						.then(() => {
							this.otpSendEmail = true
						})
				}
			}
		},
		verifyOtp () {
			this.loading = orderApi.verifyOtp(this.otp.trim())
				.then((res) => {
					if (res.data.message === 'OTP Expired') {
						this.$toasted.show('Current OTP is Expired', { icon: 'exclamation-circle' })
					} else {
						this.$emit('otpVerified')
					}
				}).catch(() => {
					this.$toasted.show('Invalid otp..')
				})
		},
		verifyOrderOTPEmail () {
			this.loading = orderApi.verifyOrderOTPEmail(this.otp)
				.then(() => {
					this.$emit('otpVerified')
				}).catch(() => {
					this.$toasted.show('Invalid otp..')
				})
		},
		sendOrConfirmOTPViaChosenMethod (verificationMethod) {
			if (verificationMethod === 'phone') {
				if (this.otpSendPhn) {
					this.verifyOtp()
				} else {
					this.sendOtp('phone')
				}
			} else if (verificationMethod === 'email') {
				if (this.otpSendEmail) {
					this.verifyOrderOTPEmail()
				} else {
					this.sendOtp('email')
				}
			}
		},
		isNumValid (evt) {
			const charCode = (evt.which) ? evt.which : event.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault()
				return false
			}

			return true
		},
		cleanPhoneNumber (e) {
			e.preventDefault()
			let pastedText = ''
			if (window.clipboardData && window.clipboardData.getData) {
				pastedText = window.clipboardData.getData('Text')
			} else if (e.clipboardData && e.clipboardData.getData) {
				pastedText = e.clipboardData.getData('text/plain')
			}
			this.otp = pastedText.replace(/\D/g, '')
		}
	}
}
</script>
